import React from 'react';
import { Field } from 'formik';
import { Props } from './Search.types';
import { KEY_BINDINGS } from 'shared/interface/globalInterface';

export const filterStartingWith = (items: Props['items'], phrase: string) => {
  return items.filter((option) =>
    (option.option || '')
      .toLowerCase()
      .split(' ')
      .some((item) => item.startsWith(phrase.toLowerCase())),
  );
};

const Search: React.FC<Props> = ({ items, onSearch }) => {
  const handleKeyUp = (e: any) => {
    const phrase = e.target.value.toLowerCase();
    const found = filterStartingWith(items, phrase);
    onSearch(phrase ? found : items);
  };

  const handleKeyPress = (e: any) => {
    if (e.which === KEY_BINDINGS.ENTER) {
      e.preventDefault();
    }
  };

  return (
    <Field
      className="select-box__input"
      name="search"
      type="text"
      onKeyUp={handleKeyUp}
      onKeyPress={handleKeyPress}
      onChange={() => {}}
      tabIndex={0}
      placeholder="Start typing.."
      autoFocus={true}
    />
  );
};

export default Search;
